import { User } from "lucide-react";

/**
 * Small circular avatar. If `src` is present, renders the image; otherwise
 * shows the first letter of `name` (or a User icon fallback).
 * Uses `object-cover` so odd aspect ratios crop nicely.
 */
export default function UserAvatar({ src, name, size = 40, className = "", testId }) {
  const dim = { width: size, height: size };
  if (src) {
    return (
      <img
        data-testid={testId}
        src={src}
        alt={name || "avatar"}
        style={dim}
        className={`rounded-full object-cover border border-white/10 bg-neutral-800 ${className}`}
      />
    );
  }
  const initial = (name || "").trim()[0]?.toUpperCase();
  return (
    <div
      data-testid={testId}
      style={dim}
      className={`flex items-center justify-center rounded-full border border-white/10 bg-gradient-to-br from-violet-700/60 to-fuchsia-700/40 text-white ${className}`}
    >
      {initial ? (
        <span className="font-display" style={{ fontSize: Math.max(12, size * 0.42) }}>{initial}</span>
      ) : (
        <User size={Math.max(12, size * 0.5)} />
      )}
    </div>
  );
}
